/* AP column-definitions family — the visible-column catalogs for the AP
 * Bills/Vendors/Scanner tables (chart-of-accounts-adjacent "Edit Columns"
 * picker) plus the small pure helpers that read/select them. Extracted out
 * of src/App.tsx (was function-body-local inside App()) into a plain,
 * framework-agnostic module so both App.tsx (its useState initializers)
 * and src/views/accounting/Accounting.tsx (the render + the AP Edit
 * Columns modal) import the SAME single source instead of App.tsx
 * duplicating it as a local type for the chunk.
 */
export type ApColDef = { key: string; label: string; width: number; sortField?: string; frozen?: boolean; pinned?: boolean; category: string; align?: 'right'; defaultHidden?: boolean }
export const AP_BILL_COL_DEFS: ApColDef[] = [
  { key: 'bill_number', label: 'Bill #', width: 110, sortField: 'bill_number', frozen: true, category: 'Bill' },
  { key: 'vendor_name', label: 'Vendor', width: 160, sortField: 'vendor_name', category: 'Bill' },
  { key: 'bill_date', label: 'Bill Date', width: 100, sortField: 'bill_date', category: 'Dates' },
  { key: 'due_date', label: 'Due Date', width: 100, sortField: 'due_date', category: 'Dates' },
  { key: 'job_name', label: 'Job', width: 120, sortField: 'job_name', category: 'Bill' },
  { key: 'status', label: 'Status', width: 90, sortField: 'status', category: 'Bill' },
  { key: 'total', label: 'Total', width: 110, sortField: 'total', align: 'right', category: 'Financial' },
  { key: 'balance', label: 'Balance', width: 110, sortField: 'balance', align: 'right', category: 'Financial' },
]
export const AP_VENDOR_COL_DEFS: ApColDef[] = [
  { key: 'name', label: 'Vendor', width: 200, sortField: 'name', frozen: true, category: 'Vendor' },
  { key: 'vendor_type', label: 'Type', width: 120, sortField: 'vendor_type', category: 'Vendor' },
  { key: 'phone', label: 'Phone', width: 140, sortField: 'phone', category: 'Vendor' },
  { key: 'email', label: 'Email', width: 180, sortField: 'email', category: 'Vendor' },
  { key: 'open_balance', label: 'Balance', width: 110, sortField: 'open_balance', align: 'right', category: 'Financial' },
  { key: 'is_1099', label: '1099', width: 60, category: 'Vendor' },
]
export const AP_SCANNER_COL_DEFS: ApColDef[] = [
  { key: 'status', label: 'Status', width: 100, sortField: 'status', category: 'Scan' },
  { key: 'vendor_name', label: 'Vendor', width: 160, sortField: 'vendor_name', category: 'Scan' },
  { key: 'invoice_number', label: 'Inv #', width: 110, sortField: 'invoice_number', category: 'Scan' },
  { key: 'po_number', label: 'PO #', width: 110, sortField: 'po_number', category: 'Scan' },
  { key: 'received', label: 'Received', width: 110, sortField: 'source_email_date', category: 'Dates' },
  { key: 'invoice_date', label: 'Invoice Date', width: 110, sortField: 'invoice_date', category: 'Dates', defaultHidden: true },
  { key: 'total_amount', label: 'Amount', width: 110, sortField: 'total_amount', align: 'right', category: 'Financial' },
  { key: 'job_name', label: 'Project', width: 160, sortField: 'job_name', category: 'Scan' },
  { key: 'confidence_score', label: 'Confidence', width: 110, category: 'Scan' },
  { key: 'source_email_from', label: 'Source', width: 150, category: 'Scan' },
  { key: 'actions', label: 'Actions', width: 140, pinned: true, category: 'Scan' },
]
export const apColDefsFor = (tab: 'bills' | 'vendors' | 'scanner') => tab === 'bills' ? AP_BILL_COL_DEFS : tab === 'vendors' ? AP_VENDOR_COL_DEFS : AP_SCANNER_COL_DEFS
export const apColMapFor = (tab: 'bills' | 'vendors' | 'scanner') => Object.fromEntries(apColDefsFor(tab).map(d => [d.key, d])) as Record<string, ApColDef>
export const apReadCols = (storageKey: string, defs: ApColDef[]): string[] => {
  try {
    const saved = localStorage.getItem(storageKey)
    if (saved) { const parsed = JSON.parse(saved); if (Array.isArray(parsed) && parsed.length > 0) return parsed }
  } catch { /* ignore */ }
  return defs.filter(d => !d.defaultHidden).map(d => d.key)
}
